import { useMemo } from 'react';
import { UserHierarchyLevel, getRoutesForLevel, isRouteAllowed } from '@practium/shared';

export const useAuthorizedRoutes = (userLevel: UserHierarchyLevel) => {
	const authorizedRoutes = useMemo(() => {
		return getRoutesForLevel(userLevel);
	}, [userLevel]);

	const checkRouteAuthorization = (path: string): boolean => {
		return isRouteAllowed(path, userLevel);
	};

	return {
		routes: authorizedRoutes,
		isRouteAuthorized: checkRouteAuthorization,
	};
};
